import { observer } from 'mobx-react'
import type { ProfileUpdateRequest } from 'models/ota/ProfileUpdateRequestModel'
import { ProfileUpdateRequestStatus } from 'models/ota/ProfileUpdateRequestModel'
import type { ProfilesStoreType, ProfileUpdateRequestsStoreType } from 'stores/RootStoreModel'
import { UpdateRequestRow, UpdateRequestState } from './UpdateRequestRow'

const getRequestState = (request: ProfileUpdateRequest) => {
    if (request.isSucceeded) {
        return UpdateRequestState.Succeeded
    }
    if (request.isFailed) {
        return UpdateRequestState.Failed
    }
    return request.status === ProfileUpdateRequestStatus.Requested ? UpdateRequestState.Pending : UpdateRequestState.InProgress
}

interface UpdateRequestRowContainerProps {
    request: ProfileUpdateRequest
    profilesStore: ProfilesStoreType
    profileUpdateRequestsStore: ProfileUpdateRequestsStoreType
    // False when the message is shown once for all the requests
    showMessage: boolean
}

// Prepares a profile update request for UpdateRequestRow, and dismisses it
export const UpdateRequestRowContainer = observer(({ request, profilesStore, profileUpdateRequestsStore, showMessage }: UpdateRequestRowContainerProps) =>
    <UpdateRequestRow {...{
        vehicleId: request.vehicle_id,
        message: showMessage ? request.message : null,
        profileTitle: profilesStore.getProfile(request.profile_id)?.title ?? request.profile_id,
        state: getRequestState(request),
        statusText: request.statusText,
        dismiss: request.isDismissible
            ? {
                // Dismissing a request that wasn't started yet cancels it
                title: request.status === ProfileUpdateRequestStatus.Requested ? 'Cancel request' : 'Dismiss',
                isDismissing: profileUpdateRequestsStore.isDismissing(request.id),
                onDismiss: () => { void profileUpdateRequestsStore.dismiss(request.id) },
            }
            : undefined,
    }} />
)
